export function getWhatsAppUrl(phone: string) {
  return `https://api.whatsapp.com/send/?lang=ru&phone=${phone}`;
}
